import {
    GET_REWARDS_SETTINGS,
    GET_REWARDS_SETTINGS_SUCCESS,
    GET_REWARDS_SETTINGS_FAILURE,
    TOGGLE_REWARDS_SETTING,
    TOGGLE_REWARDS_SETTING_SUCCESS,
    TOGGLE_REWARDS_SETTING_FAILURE,
    GET_REWARDS_CONFIG,
    GET_REWARDS_CONFIG_SUCCESS,
    GET_REWARDS_CONFIG_FAILURE,
    UPDATE_REFERRAL_CONFIG,
    UPDATE_REFERRAL_CONFIG_SUCCESS,
    UPDATE_REFERRAL_CONFIG_FAILURE,
    UPDATE_FIRST_PURCHASE_CONFIG,
    UPDATE_FIRST_PURCHASE_CONFIG_SUCCESS,
    UPDATE_FIRST_PURCHASE_CONFIG_FAILURE,
    GET_DAILY_REWARDS,
    GET_DAILY_REWARDS_SUCCESS,
    GET_DAILY_REWARDS_FAILURE,
    UPDATE_DAILY_REWARDS,
    UPDATE_DAILY_REWARDS_SUCCESS,
    UPDATE_DAILY_REWARDS_FAILURE,
    GET_FREE_PLAY_CONFIG,
    GET_FREE_PLAY_CONFIG_SUCCESS,
    GET_FREE_PLAY_CONFIG_FAILURE,
    UPDATE_FREE_PLAY_CONFIG,
    UPDATE_FREE_PLAY_CONFIG_SUCCESS,
    UPDATE_FREE_PLAY_CONFIG_FAILURE,
} from "../constants";

export default class RewardsAction {

    // ── Settings (toggle list) ─────────────────────────────────────────────
    static GetSettings() { return { type: GET_REWARDS_SETTINGS }; }
    static GetSettings_Success(payload) { return { type: GET_REWARDS_SETTINGS_SUCCESS, payload }; }
    static GetSettings_Failure(payload) { return { type: GET_REWARDS_SETTINGS_FAILURE, payload }; }

    // ── Toggle a single setting ────────────────────────────────────────────
    static ToggleSetting(payload, cb, onError) { return { type: TOGGLE_REWARDS_SETTING, payload, cb, onError }; }
    static ToggleSetting_Success(payload) { return { type: TOGGLE_REWARDS_SETTING_SUCCESS, payload }; }
    static ToggleSetting_Failure(payload) { return { type: TOGGLE_REWARDS_SETTING_FAILURE, payload }; }

    // ── Get config for a specific key ─────────────────────────────────────
    static GetSettingsConfig(key) { return { type: GET_REWARDS_CONFIG, key }; }
    static GetSettingsConfig_Success(payload) { return { type: GET_REWARDS_CONFIG_SUCCESS, payload }; }
    static GetSettingsConfig_Failure(payload) { return { type: GET_REWARDS_CONFIG_FAILURE, payload }; }

    // ── Update referral config ─────────────────────────────────────────────
    static UpdateReferralConfig(payload, cb) { return { type: UPDATE_REFERRAL_CONFIG, payload, cb }; }
    static UpdateReferralConfig_Success(payload) { return { type: UPDATE_REFERRAL_CONFIG_SUCCESS, payload }; }
    static UpdateReferralConfig_Failure(payload) { return { type: UPDATE_REFERRAL_CONFIG_FAILURE, payload }; }

    // ── Update first purchase config ───────────────────────────────────────
    static UpdateFirstPurchaseConfig(payload, cb) { return { type: UPDATE_FIRST_PURCHASE_CONFIG, payload, cb }; }
    static UpdateFirstPurchaseConfig_Success(payload) { return { type: UPDATE_FIRST_PURCHASE_CONFIG_SUCCESS, payload }; }
    static UpdateFirstPurchaseConfig_Failure(payload) { return { type: UPDATE_FIRST_PURCHASE_CONFIG_FAILURE, payload }; }

    // ── Daily rewards ──────────────────────────────────────────────────────
    static GetDailyRewards() { return { type: GET_DAILY_REWARDS }; }
    static GetDailyRewards_Success(payload) { return { type: GET_DAILY_REWARDS_SUCCESS, payload }; }
    static GetDailyRewards_Failure(payload) { return { type: GET_DAILY_REWARDS_FAILURE, payload }; }

    static UpdateDailyRewards(payload, cb) { return { type: UPDATE_DAILY_REWARDS, payload, cb }; }
    static UpdateDailyRewards_Success(payload) { return { type: UPDATE_DAILY_REWARDS_SUCCESS, payload }; }
    static UpdateDailyRewards_Failure(payload) { return { type: UPDATE_DAILY_REWARDS_FAILURE, payload }; }

    // ── Free play config ───────────────────────────────────────────────────
    static GetFreePlayConfig() { return { type: GET_FREE_PLAY_CONFIG }; }
    static GetFreePlayConfig_Success(payload) { return { type: GET_FREE_PLAY_CONFIG_SUCCESS, payload }; }
    static GetFreePlayConfig_Failure(payload) { return { type: GET_FREE_PLAY_CONFIG_FAILURE, payload }; }

    static UpdateFreePlayConfig(payload, cb) { return { type: UPDATE_FREE_PLAY_CONFIG, payload, cb }; }
    static UpdateFreePlayConfig_Success(payload) { return { type: UPDATE_FREE_PLAY_CONFIG_SUCCESS, payload }; }
    static UpdateFreePlayConfig_Failure(payload) { return { type: UPDATE_FREE_PLAY_CONFIG_FAILURE, payload }; }
}

